import { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import { START_TOUCH } from '@confluence/navdex/entry-points/NavdexPointType.ts';

export const useHomeViewedAnalytics = (): void => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		createAnalyticsEvent({
			type: 'sendTrackEvent',
			data: {
				action: 'viewed',
				actionSubject: 'home',
				source: 'homeScreen',
				attributes: {
					navdexPointType: START_TOUCH,
				},
			},
		}).fire();
	}, [createAnalyticsEvent]);
};
